import { render, staticRenderFns } from "./pricehelp.vue?vue&type=template&id=e838afee&"
import script from "./pricehelp.vue?vue&type=script&lang=js&"
export * from "./pricehelp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('e838afee')) {
      api.createRecord('e838afee', component.options)
    } else {
      api.reload('e838afee', component.options)
    }
    module.hot.accept("./pricehelp.vue?vue&type=template&id=e838afee&", function () {
      api.rerender('e838afee', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-8w1RpJwLpr5Np/JS/pricehelp.vue"
export default component.exports